// src/LandingPage.js

import { auth } from "./firebase";
import { signOut, onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      console.log("👤 Current user on landing:", firebaseUser);
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log("✅ Signed out successfully");
      alert("You've been signed out.");
      setUser(null);
    } catch (err) {
      console.error("Logout failed:", err);
      alert("Logout failed.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-8 text-center">
      <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
        🎬 Reals Automated
      </h1>

      <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl">
        Automate your weekly real estate content with AI-powered voiceovers,
        professional b-roll, and hands-free publishing. Built for agents who
        want to scale without the stress.
      </p>

      <div className="flex flex-col gap-4 w-full max-w-xs">
        {/* 🔓 Free access to beta users */}
        <button
          onClick={() => navigate("/dashboard")}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded text-lg shadow-md"
        >
          🚀 Join Beta (Free Access)
        </button>

        {/* 🔐 Exclusive members login for upgraded b-roll experience */}
        <button
          onClick={() => navigate("/members")}
          className="bg-black hover:bg-gray-900 text-white px-6 py-3 rounded text-lg shadow-md"
        >
          🔐 Members Login (Exclusive)
        </button>

        {/* 🧾 Sign out if logged in */}
        {user && (
          <button
            onClick={handleSignOut}
            className="bg-gray-300 hover:bg-gray-400 text-black px-6 py-3 rounded text-lg shadow-md"
          >
            🔓 Manual Sign Out
          </button>
        )}
      </div>
    </div>
  );
}
